/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AmountDecimalValidationError,
  AmountDecimalValidationError$inboundSchema,
  AmountDecimalValidationError$Outbound,
  AmountDecimalValidationError$outboundSchema,
} from "./amountdecimalvalidationerror.js";
import {
  CreateTransferLineItemOptionValidationError,
  CreateTransferLineItemOptionValidationError$inboundSchema,
  CreateTransferLineItemOptionValidationError$Outbound,
  CreateTransferLineItemOptionValidationError$outboundSchema,
} from "./createtransferlineitemoptionvalidationerror.js";

export type CreateTransferLineItemValidationError = {
  productID?: string | undefined;
  name?: string | undefined;
  basePrice?: AmountDecimalValidationError | undefined;
  options?:
    | { [k: string]: CreateTransferLineItemOptionValidationError }
    | undefined;
  quantity?: string | undefined;
  imageIDs?: string | undefined;
};

/** @internal */
export const CreateTransferLineItemValidationError$inboundSchema: z.ZodType<
  CreateTransferLineItemValidationError,
  z.ZodTypeDef,
  unknown
> = z.object({
  productID: z.string().optional(),
  name: z.string().optional(),
  basePrice: AmountDecimalValidationError$inboundSchema.optional(),
  options: z.record(CreateTransferLineItemOptionValidationError$inboundSchema)
    .optional(),
  quantity: z.string().optional(),
  imageIDs: z.string().optional(),
});
/** @internal */
export type CreateTransferLineItemValidationError$Outbound = {
  productID?: string | undefined;
  name?: string | undefined;
  basePrice?: AmountDecimalValidationError$Outbound | undefined;
  options?: {
    [k: string]: CreateTransferLineItemOptionValidationError$Outbound;
  } | undefined;
  quantity?: string | undefined;
  imageIDs?: string | undefined;
};

/** @internal */
export const CreateTransferLineItemValidationError$outboundSchema: z.ZodType<
  CreateTransferLineItemValidationError$Outbound,
  z.ZodTypeDef,
  CreateTransferLineItemValidationError
> = z.object({
  productID: z.string().optional(),
  name: z.string().optional(),
  basePrice: AmountDecimalValidationError$outboundSchema.optional(),
  options: z.record(CreateTransferLineItemOptionValidationError$outboundSchema)
    .optional(),
  quantity: z.string().optional(),
  imageIDs: z.string().optional(),
});

export function createTransferLineItemValidationErrorToJSON(
  createTransferLineItemValidationError: CreateTransferLineItemValidationError,
): string {
  return JSON.stringify(
    CreateTransferLineItemValidationError$outboundSchema.parse(
      createTransferLineItemValidationError,
    ),
  );
}
export function createTransferLineItemValidationErrorFromJSON(
  jsonString: string,
): SafeParseResult<CreateTransferLineItemValidationError, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      CreateTransferLineItemValidationError$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateTransferLineItemValidationError' from JSON`,
  );
}
